import { z } from "zod";
const configurationTestResultIdSchema = z.uuid().brand();
function asConfigurationTestResultId(id) {
  return configurationTestResultIdSchema.parse(id);
}
const configurationTestResultResourceTypes = [
  "playbook",
  "teammateAgent"
];
const configurationTestResultResourceTypeSchema = z.enum(
  configurationTestResultResourceTypes
);
function checkConfigurationTestResultResourceType(testResult, resourceType) {
  return testResult.resource_type === resourceType;
}
export {
  asConfigurationTestResultId,
  checkConfigurationTestResultResourceType,
  configurationTestResultIdSchema,
  configurationTestResultResourceTypeSchema,
  configurationTestResultResourceTypes
};
//# sourceMappingURL=configurationTestResult.js.map
